import { useState } from "react";
import logo from "../../assets/icons/logo.svg";
import Input from "../../components/input";
import arrow from "../../assets/icons/arrow.svg";
import flutterwaveIcon from "../../assets/icons/flutterwave.svg";
import paystackIcon from "../../assets/icons/paystack.svg";
import { useVirtualAccountDetails } from "../reuseableEffects";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../components/Spinners/Spinner";
import { useDispatch, useSelector } from "react-redux";
import close from "../../assets/icons/closeRed.svg";
import { showSuccessMessage } from "../../hooks/constants";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FlutterPayment } from "../../hooks/local/reducer";
import Navbar from "../../components/navbar";
import Button from "../../components/button";

const Donation = () => {
  const { campaignReference } = useParams();
  const accountDetails = useVirtualAccountDetails(campaignReference);
  const { title } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.user.loading);
  document.title = `${loading? "Mosquepay" : "Donate! - Mosquepay"}`;

  const [selectedOption, setSelectedOption] = useState("Bank Transfer");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [customAmount, setCustomAmount] = useState("");

  const predefinedAmounts = [200, 500, 1000, 2000];

  const handlePredefinedClick = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount("");
    payWithFlutterForm.setFieldValue("amount", amount);
  };

  const handleCustomChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    setCustomAmount(value);
    setSelectedAmount("");
    payWithFlutterForm.setFieldValue("amount", value ? parseInt(value) : "");
  };

  const formatAmount = (amount) =>
    new Intl.NumberFormat().format(amount);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(accountDetails?.account_no || "")
      .then(() => {
        showSuccessMessage("Account number copied!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const payWithFlutterForm = useFormik({
    initialValues: {
      user_id: "1",
      email: "",
      phonenumber: "",
      name: "",
      amount: "",
      country_code: "NGN",
      ananymous: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phonenumber: Yup.string()
        .required("Enter your phone number")
        .matches(/^\d{11}$/, "Phone number should be 11 digits"),
      name: Yup.string().required("Enter your name"),
      amount: Yup.number()
        .typeError("Amount must be a number")
        .min(1, "Amount must be at least ₦1")
        .required("Enter a valid amount"),
    }),
    onSubmit: async (values) => {
      const { payload } = await dispatch(FlutterPayment(values));
      if (payload.status_code === "0") {
        showSuccessMessage("Payment successful!");
      }
    },
  });

  return (
    <div>
      <Spinner loading={loading} />
      <Navbar />
      <div className="px-4 md:px-12 mt-24 pb-16">
        <div className="bg-white max-h-[80%] md:max-h-[90%] w-full md:w-[70%] lg:w-[60%] rounded border">
          <div className="grid gap-4 px-6 md:px-10 py-5">
            <div className="grid">
              <span className="text-secondary">You're about to support:</span>
              <span>{decodeURIComponent(title)}</span>
            </div>
            <div className="overflow-x-auto whitespace-nowrap">
              <div className="flex text-sm bg-white border rounded py-3 w-fit divide-x">
                <span
                  className={`px-4 cursor-pointer ${
                    selectedOption === "Bank Transfer"
                      ? "text-brandGreen font-semibold"
                      : ""
                  }`}
                  onClick={() => setSelectedOption("Bank Transfer")}
                >
                  Bank transfer
                </span>
                <span
                  className={`px-4 cursor-pointer ${
                    selectedOption === "Card Donations"
                      ? "text-brandGreen font-semibold"
                      : ""
                  }`}
                  onClick={() => setSelectedOption("Card Donations")}
                >
                  Card donations
                </span>
                <span
                  className={`px-4 cursor-pointer ${
                    selectedOption === "International Donations"
                      ? "text-brandGreen font-semibold"
                      : ""
                  }`}
                  onClick={() => setSelectedOption("International Donations")}
                >
                  International donations
                </span>
              </div>
            </div>
          </div>
          <div className="px-6 md:px-10 pb-5 mt-4">
            {selectedOption === "Bank Transfer" && (
              <div className="grid gap-3">
                <div className="grid pb-1 border-b">
                  <span className="text-sm text-secondary">Bank name:</span>
                  <span>Providus bank</span>
                </div>
                <div className="grid pb-1 border-b">
                  <span className="text-sm text-secondary">Account number:</span>
                  <div className="flex justify-between items-center">
                    <span className="tracking-widest">
                      {accountDetails?.account_no}
                    </span>
                    <span
                      onClick={handleCopy}
                      className="text-brandGreen text-sm font-medium cursor-pointer"
                    >
                      Copy
                    </span>
                  </div>
                </div>
                <div className="grid pb-1">
                  <span className="text-sm text-secondary">Account name:</span>
                  <span>Zippyworld ({accountDetails?.account_name})</span>
                </div>
              </div>
            )}
            {selectedOption === "Card Donations" && (
              <form
                onSubmit={payWithFlutterForm.handleSubmit}
                className="grid gap-4"
              >
                <div className="flex gap-4 text-sm">
                  
                  <span>Donate anonymously</span>
                </div>
                <Input
                  label="Your name"
                  type="text"
                  name="name"
                  value={payWithFlutterForm.values.name}
                  onChange={payWithFlutterForm.handleChange}
                  onBlur={payWithFlutterForm.handleBlur}
                  onError={
                    payWithFlutterForm.touched.name &&
                    payWithFlutterForm.errors.name
                      ? payWithFlutterForm.errors.name
                      : null
                  }
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Phone number"
                    type="text"
                    name="phonenumber"
                    value={payWithFlutterForm.values.phonenumber}
                    onChange={payWithFlutterForm.handleChange}
                    onBlur={payWithFlutterForm.handleBlur}
                    onError={
                      payWithFlutterForm.touched.phonenumber &&
                      payWithFlutterForm.errors.phonenumber
                        ? payWithFlutterForm.errors.phonenumber
                        : null
                    }
                  />
                  <Input
                    label="Email address"
                    type="text"
                    name="email"
                    value={payWithFlutterForm.values.email}
                    onChange={payWithFlutterForm.handleChange}
                    onBlur={payWithFlutterForm.handleBlur}
                    onError={
                      payWithFlutterForm.touched.email &&
                      payWithFlutterForm.errors.email
                        ? payWithFlutterForm.errors.email
                        : null
                    }
                  />
                </div>
                <div className="grid gap-1">
                  <p className="text-sm">Select an amount:</p>
                  <div className="grid grid-cols-3 gap-4 items-center">
                    {predefinedAmounts.map((amount) => (
                      <span
                        key={amount}
                        className={`w-full px-4 py-5 md:py-4 border text-sm rounded text-center cursor-pointer ${
                          selectedAmount === amount
                            ? "bg-brandGreen text-white"
                            : ""
                        }`}
                        onClick={() => handlePredefinedClick(amount)}
                      >
                        &#8358;{formatAmount(amount)}
                      </span>
                    ))}
                    <input
                      placeholder="Custom amount"
                      type="text"
                      value={customAmount}
                      onChange={handleCustomChange}
                      className={`w-full px-4 py-5 md:py-4 border text-sm focus:outline focus:outline-brandGreen/50 rounded ${
                        customAmount ? "border-brandGreen" : ""
                      }`}
                    />
                  </div>
                  <span className="text-red-500 text-sm">
                    {payWithFlutterForm.touched.amount &&
                    payWithFlutterForm.errors.amount
                      ? payWithFlutterForm.errors.amount
                      : null}
                  </span>
                </div>
                <Button
                  buttonText="Donate"
                  loading={loading}
                  otherStyles="bg-black text-white"
                />
              </form>
            )}
            {selectedOption === "International Donations" && (
              <p>International donation details will go here.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donation;
